import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { Link } from 'react-router-dom';
import Api from '../../Auth/Api';

const truncateText = (text, maxLength) => {
	if (!text) return '';
	return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

const SidebarContent = ({
	date,
	setDate,
	formatShortWeekday,
	nivel,
	dataAulasAdicionadas,
	dataUsuariosGestor
}) => {
	const token = JSON.parse(localStorage.getItem("user_token"));
	const [diasComAgendamentos, setDiasComAgendamentos] = useState(new Set());
	const [mesAnoCalendario, setMesAnoCalendario] = useState({ mes: new Date().getMonth() + 1, ano: new Date().getFullYear() });

	// Buscar dias com agendamentos para o calendário (apenas para Gestor, RH e Admin)
	useEffect(() => {
		// Só buscar agendamentos se o usuário tiver permissão
		if (!['Gestor', 'RH', 'Administrador'].includes(nivel)) {
			return;
		}

		async function buscarDiasComAgendamentos() {
			try {
				const response = await Api.get(
					`/api/agendamentos-treinamentos?mes=${mesAnoCalendario.mes}&ano=${mesAnoCalendario.ano}`,
					{
						headers: { Authorization: `Bearer ${token}` }
					}
				);
				
				// Criar um Set com as datas que têm agendamentos (apenas pendentes e confirmados)
				const dias = new Set();
				response.data.forEach(ag => {
					if (ag.status !== 'cancelado' && ag.data_treinamento) {
						// Garantir formato YYYY-MM-DD
						let dataFormatada = ag.data_treinamento;
						if (dataFormatada.includes('T')) {
							dataFormatada = dataFormatada.split('T')[0];
						}
						// Se vier no formato brasileiro, converter
						if (dataFormatada.includes('/')) {
							const [dia, mes, ano] = dataFormatada.split('/');
							dataFormatada = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
						}
						dias.add(dataFormatada);
					}
				});
				setDiasComAgendamentos(dias);
			} catch (error) {
				console.error('Erro ao buscar dias com agendamentos:', error);
			}
		}
		buscarDiasComAgendamentos();
	}, [mesAnoCalendario, token, nivel]);

	return (
		<>
			<div className="pb-3">
				<Calendar
					formatShortWeekday={formatShortWeekday}
					onChange={(date) => {
						setDate(date);
						// Atualizar mês/ano quando navegar no calendário
						const novoMes = date.getMonth() + 1;
						const novoAno = date.getFullYear();
						if (novoMes !== mesAnoCalendario.mes || novoAno !== mesAnoCalendario.ano) {
							setMesAnoCalendario({ mes: novoMes, ano: novoAno });
						}
					}}
					onActiveStartDateChange={({ activeStartDate }) => {
						// Atualizar quando navegar para outro mês
						const novoMes = activeStartDate.getMonth() + 1;
						const novoAno = activeStartDate.getFullYear();
						if (novoMes !== mesAnoCalendario.mes || novoAno !== mesAnoCalendario.ano) {
							setMesAnoCalendario({ mes: novoMes, ano: novoAno });
						}
					}}
					value={date}
					locale="pt-BR"
					className="w-100"
					tileContent={({ date, view }) => {
						// Só mostrar indicador na view de mês
						if (view === 'month') {
							const ano = date.getFullYear();
							const mes = String(date.getMonth() + 1).padStart(2, '0');
							const dia = String(date.getDate()).padStart(2, '0');
							const dataFormatada = `${ano}-${mes}-${dia}`;
							
							if (diasComAgendamentos.has(dataFormatada)) {
								return (
									<div className="d-flex justify-content-center align-items-center position-absolute" style={{ top: '2px', right: '2px', width: '8px', height: '8px' }}>
										<span className="badge bg-primary rounded-circle d-inline-block" style={{ width: '8px', height: '8px', padding: 0 }}></span>
									</div>
								);
							}
						}
						return null;
					}}
					tileClassName={({ date, view }) => {
						if (view === 'month') {
							const ano = date.getFullYear();
							const mes = String(date.getMonth() + 1).padStart(2, '0');
							const dia = String(date.getDate()).padStart(2, '0');
							const dataFormatada = `${ano}-${mes}-${dia}`;
							return diasComAgendamentos.has(dataFormatada) ? 'has-agendamento' : '';
						}
						return '';
					}}
				/>
				<div className="my-3">
					<Link to="/agendamentos-treinamentos">
						<button
							type="button"
							className="btn btn-outline-primary rounded py-2 w-100"
							tabIndex="0"
						>
							Ver calendário completo
						</button>
					</Link>
				</div>
			</div>

			{(nivel === 'Administrador' || nivel === 'RH') && (
				<div className="classes rounded bg-primary flex-fill text-white p-4 mb-6 mb-md-0">
					<span className="d-flex justify-content-center fs-5 fw-500 text-center">
						Novas Aulas
					</span>
					<div className="container-fluid mt-2">
						<div className="row">
							{dataAulasAdicionadas.map((value) => (
								<div
									key={value.id}
									className="d-flex flex-column rounded bg-white text-black text-dark p-3 my-2"
								>
									<span className="fw-bold fs-7 text-pretty mb-1" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={value.titulo}>
										{truncateText(value.titulo, 30)} - {truncateText(value.nome_modulo, 25)}
									</span>
									<small className="text-muted fs-8" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={value.nome_curso}>
										{truncateText(value.nome_curso, 25)}
									</small>
								</div>
							))}
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default SidebarContent; 